import { GroupType } from "./group-type.mjs"

export const UNLOCKABLE_GROUP_TYPES = Object.freeze([GroupType.LEADING_SUMMARY, GroupType.INTRODUCTION, GroupType.ADD])

export const OWNERSHIP_TRACKED_FIELD = Object.freeze({
    [GroupType.ADD]: "taskOwnershipTracked",
    [GroupType.LEADING_SUMMARY]: "leadingSummaryOwnershipTracked",
    [GroupType.INTRODUCTION]: "introductionOwnershipTracked",
})

export function isUnlockableGroup(group) {
    if (!group || !UNLOCKABLE_GROUP_TYPES.includes(group.type)) return false
    return Boolean(group[OWNERSHIP_TRACKED_FIELD[group.type]])
}
